// Only supports US country code for now.

export function parsePhoneNumber(phone: string) {
  const parsedPhone = phone.replace(/[^\d]/g, "");

  if (parsedPhone.length == 10) {
    return `+1${parsedPhone}`;
  }

  // Has country code
  if (parsedPhone.length == 11 && parsedPhone[0] === "1") {
    return `+${parsedPhone}`;
  }

  return "";
}
